<div *ngIf="displayedComments && displayedComments.length > 0; else noComments">
    <div class="review-card" *ngFor="let review of displayedComments" (click)="redirectt(review.providerId)">
        <div class="review-header">
            <div class="user-info">
                <span class="user-name">
                    {{ review.name ? review.name : 'Anónimo' }}
                    <label class="user-name-calification">
                        {{ review.rating }}
                        <fa-icon [icon]="faStarRegular"></fa-icon>
                    </label>
                </span>
            </div>
            <div class="review-date">{{review.createdAt}}</div>
        </div>

        <div class="review-content">
            <div class="row h-100">
                <div class="col-10 my-auto">
                    <p class="review-text">
                        {{ displayText(review) }}
                        <span *ngIf="shouldShowToggle(review)" class="see-more" (click)="toggleText()">
                            {{ showFullText ? 'ver menos' : 'ver más' }}
                        </span>
                    </p>
                </div>
                <div class="col-2 my-auto pad0">
                    <img *ngIf="review.image" [src]="review.image" alt="Review image" class="comment-image">
                </div>
            </div>
        </div>

        <div class="review-footer">
            <!-- <div class="likes-container">
                <img src="/assets/img/thumb_up.svg" alt="Like" class="like-icon">
                <span class="like-count">{{review.like || 0}}</span>
            </div> -->
            <div class="likes-container" (click)="toggleLike(review)">
                <fa-icon [icon]="faThumbsUp" [class.liked]="review.userLike" class="like-icon">
                </fa-icon>
                <span class="like-count">{{review.like || 0}}</span>
            </div>
        </div>
    </div>
</div>
<app-paginator *ngIf="allPaginator.length > 10" [items]="allPaginator" [itemsPerPage]="10"
    (pageChange)="onPageDataChange($event)">
</app-paginator>
<ng-template #noComments>
    <div class="no-comments-message">
        {{message}}
    </div>
</ng-template>